import { Space } from 'antd';
import styled from 'styled-components';

/**
 * Elemento che estende il componente Space.Compact di Ant Design per correggerne la visualizzazione
 */
export const $SpaceCompact = styled(Space.Compact)`
  z-index: 1;
  position: relative;
`;

/**
 * Versione di SpaceCompact che gestisce anche le **etichette** dei campi di
 * input con uno spacing corretto dei pulsanti (es. "Elimina" a DX)
 */
export const $LabeledSpaceCompact = styled(Space.Compact)`
  &&& {
    z-index: 1;
    position: relative;
    margin-top: 8px;

    > .ant-form-item {
      flex: 1;
      padding-top: 0;
    }
  }
`;
